import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Portfolio } from './components/Portfolio';
import { Testimonials } from './components/Testimonials';
import { AIAssistant } from './components/AIAssistant';
import { Blog } from './components/Blog';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  return <div className="w-full min-h-screen bg-gradient-to-b from-[#0a1628] to-[#1b2b45]" data-id="element-0">
      <Header data-id="element-1" />
      <Hero data-id="element-2" />
      <About data-id="element-3" />
      <Services data-id="element-4" />
      <Portfolio data-id="element-5" />
      <AIAssistant data-id="element-6" />
      <Testimonials data-id="element-7" />
      <Blog data-id="element-8" />
      <Contact data-id="element-9" />
      <Footer data-id="element-10" />
      <ScrollToTop data-id="element-11" />
    </div>;
}